import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { CookiesService } from './cookies.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-loginpage',
  standalone:true,
  imports: [CommonModule,ReactiveFormsModule,FormsModule],
  templateUrl: './loginpage.component.html',
  styleUrl: './loginpage.component.css'
})
export class LoginpageComponent implements OnInit {
loginForm!: FormGroup;
  isOpen = false;
releaseNotes: any[] = [];
publicKey: string = '';

toggleNotes() {
  this.isOpen = !this.isOpen;
}

constructor(private router: Router,private fb: FormBuilder,private loginservice:LoginService,private cookies:CookiesService,private toastr:ToastrService) {}

ngOnInit() {
   this.loginForm = this.fb.group({
    username: [''],
    password: [''],
    captcha: ['']
  });
    this.cookies.deleteCookie('userData');
     localStorage.clear();
// this.loginservice.getpublickey().subscribe({
//   next: (res: any) => {
//     this.publicKey = res.public_key;

//     console.log('Public key received');
//   },
//   error: (err) => {
//     console.error('Failed to get public key', err);
//   }
// });
}
showPassword = false;

togglePassword() {
  this.showPassword = !this.showPassword;
}
async encryptPassword(
  password: string,
  publicKeyPem: string
): Promise<string> {

  // 1. Create timestamp
  const timestamp = Date.now();

  // 2. Create random nonce
  const nonceArray = new Uint8Array(16);
  crypto.getRandomValues(nonceArray);

  const nonce = Array.from(nonceArray)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');

  // 3. Create payload expected by Python
  const payload = {
    p: password,
    // ts: timestamp,
    n: nonce
  };

  // 4. Convert payload to JSON
  const jsonPayload = JSON.stringify(payload);

  // 5. Remove PEM headers
  const pemContents = publicKeyPem
    .replace('-----BEGIN PUBLIC KEY-----', '')
    .replace('-----END PUBLIC KEY-----', '')
    .replace(/\s/g, '');

  // 6. Base64 → binary
  const binaryDer = Uint8Array.from(
    atob(pemContents),
    c => c.charCodeAt(0)
  );

  // 7. Import RSA public key
  const cryptoKey = await crypto.subtle.importKey(
    'spki',
    binaryDer.buffer,
    {
      name: 'RSA-OAEP',
      hash: 'SHA-256'
    },
    false,
    ['encrypt']
  );

  // 8. Convert JSON to bytes
  const encodedPayload =
    new TextEncoder().encode(jsonPayload);

  // 9. Encrypt JSON using RSA-OAEP
  const encrypted =
    await crypto.subtle.encrypt(
      {
        name: 'RSA-OAEP'
      },
      cryptoKey,
      encodedPayload
    );

  // 10. Convert encrypted bytes to Base64
  return btoa(
    String.fromCharCode(
      ...new Uint8Array(encrypted)
    )
  );
}


//  async onLogin() {


//   const username = this.loginForm.value.username?.trim();
//   const password = this.loginForm.value.password?.trim();

//   // Both empty
//   if (!username && !password) {
//     this.toastr.error(
//       'Please enter username and password',
//       'Error'
//     );
//     return;
//   }

//   // Username empty
//   if (!username) {
//     this.toastr.error(
//       'Please enter username',
//       'Error'
//     );
//     return;
//   }

//   // Password empty
//   if (!password) {
//     this.toastr.error(
//       'Please enter password',
//       'Error'
//     );
//     return;
//   }

// const encryptedPassword =
//   await this.encryptPassword(
//     password,
//     this.publicKey
//   );

// const payload = {
//   username: username,
//   password: encryptedPassword
// };




//   this.loginservice
//     .login(payload)
//     .subscribe({

//       next: (res: any) => {
//     const isActive = res?.is_active;

//   if (!isActive) {

//     this.toastr.error(
//       'The user has been locked, please contact administrator',
//       'Error'
//     );
//      this.loginForm.reset();

//     return;
//   }

//         this.loginForm.reset();

//         // ✅ STORE COOKIE
        
//   const cookieData = JSON.parse(JSON.stringify(res));

//   // ✅ save trackers in localStorage
//   const projectTrackers =
//     cookieData.redmine_context?.projects?.map((p: any) => ({
//       project_id: p.project_id,
//       trackers: p.trackers
//     })) || [];

//   localStorage.setItem(
//     'projectTrackers',
//     JSON.stringify(projectTrackers)
//   );

//   // ✅ remove trackers from cookie data
//  localStorage.setItem(
//   'projectsData',
//   JSON.stringify(cookieData.redmine_context?.projects || [])
// );

// // ✅ Remove projects from cookie
// delete cookieData.redmine_context.projects;



//   // ✅ store reduced data in cookie
//   this.cookies.setCookie(
//     'userData',
//     cookieData,
//     1
//   );

//         // ✅ SUCCESS TOASTR
//         this.toastr.success(
//           'Login successful',
//           'Success'
//         );

//         // ✅ PASSWORD CHECK
//         const passwordStatus =
//           res?.password_status;

//         // 🔥 FORCE CHANGE PASSWORD
//         if (passwordStatus === false) {

//           this.router.navigate([
//             '/change-password'
//           ]);

//           return;

//         }

//         // ✅ ROLE
//         const role =
//           res?.existing_role
//             ?.toLowerCase();

//         // 🔥 AGENT
//         if (role === 'agent') {
          

//           this.router.navigate([
//             '/landing/lists'
//           ]);

//           return;

//         }
        

//         // 🔥 MANAGER / PMO 
//         this.router.navigate([
//           '/landing'
//         ]);

//       },

//       error: (err) => {

        

//         // ✅ ERROR TOASTR
//         this.toastr.error(
//           'Invalid username or password',
//           'Error'
//         );

//       }

//     });

// }
async onLogin() {

  const username = this.loginForm.value.username?.trim();
  const password = this.loginForm.value.password?.trim();

  // Both empty
  if (!username && !password) {
    this.toastr.error(
      'Please enter username and password',
      'Error'
    );
    return;
  }

  // Username empty
  if (!username) {
    this.toastr.error(
      'Please enter username',
      'Error'
    );
    return;
  }

  // Password empty
  if (!password) {
    this.toastr.error(
      'Please enter password',
      'Error'
    );
    return;
  }

  try {

    let payload: any;

    // Public key available → encrypt password
    if (this.publicKey) {

      const encryptedPassword =
        await this.encryptPassword(
          password,
          this.publicKey
        );

      payload = {
        username: username,
        encrypted_password: encryptedPassword
      };

    } else {

      // Public key not available → normal login
      payload = {
        username: username,
        password: password
      };
    }

    this.loginservice
      .login(payload)
      .subscribe({

        next: (res: any) => {

          const isActive = res?.is_active;

          if (!isActive) {

            this.toastr.error(
              'The user has been locked, please contact administrator',
              'Error'
            );

            this.loginForm.reset();

            return;
          }

          this.loginForm.reset();

          // STORE COOKIE
          const cookieData = JSON.parse(JSON.stringify(res));

          // Save trackers in localStorage
          const projectTrackers =
            cookieData.redmine_context?.projects?.map((p: any) => ({
              project_id: p.project_id,
              trackers: p.trackers
            })) || [];

          localStorage.setItem(
            'projectTrackers',
            JSON.stringify(projectTrackers)
          );

          // Save projects data
          localStorage.setItem(
            'projectsData',
            JSON.stringify(
              cookieData.redmine_context?.projects || []
            )
          );

          // Remove projects from cookie data
          delete cookieData.redmine_context.projects;

          // Store reduced data in cookie
          this.cookies.setCookie(
            'userData',
            cookieData,
            1
          );

          // SUCCESS TOASTR
          this.toastr.success(
            'Login successful',
            'Success'
          );

          // PASSWORD CHECK
          const passwordStatus =
            res?.password_status;

          // FORCE CHANGE PASSWORD
          if (passwordStatus === false) {

            this.router.navigate([
              '/change-password'
            ]);

            return;
          }

          // ROLE
          const role =
            res?.existing_role?.toLowerCase();

          // AGENT
          if (role === 'agent') {

            this.router.navigate([
              '/landing/lists'
            ]);

            return;
          }

          // MANAGER / PMO
          this.router.navigate([
            '/landing'
          ]);
        },

        error: (err) => {

          this.toastr.error(
            'Invalid username or password',
            'Error'
          );

        }

      });

  } catch (error) {

    console.error(
      'Password encryption failed:',
      error
    );

    this.toastr.error(
      'Unable to secure login request',
      'Error'
    );
  }
}
goToChangePassword(){

  this.router.navigate(['/change-password']);

}
goToForgotPassword(): void {
  console.log('hello')
  this.router.navigate(['/forgot-password']);
}
}